export default [
  {
    name: 'Name',
    field: 'name',
    width: 'large',
  },
  {
    name: 'Offers',
    field: 'body',
    width: 'large',
  },
  {
    name: 'Status',
    field: 'status',
    width: 'small',
  },
  {
    name: 'Delivery Method',
    field: 'delivery_method',
    width: 'medium',
  }
];



/** WEBPACK FOOTER **
 ** ./src/tables/autoCampaigns.js
 **/